// =============================================================================
// TRADEMANIA LANDING PAGE - MAIN JAVASCRIPT
// =============================================================================
// Clean, blank JavaScript file ready for development
// Follows AIQ standards with comprehensive documentation

// -----------------------------------------------------------------------------
// 1. INITIALIZATION
// -----------------------------------------------------------------------------

/**
 * Main application initialization
 * Ready for your custom functionality
 */
document.addEventListener('DOMContentLoaded', function() {
    console.log('🚀 TradeMania Landing Page - Ready for development');

    // -------------------------------------------------------------------------
    // Header menu (hamburger + animated dropdown)
    // -------------------------------------------------------------------------

    const menuButton = document.querySelector('.menu-button');
    const menuPanel = document.querySelector('#site-menu');

    if (menuButton instanceof HTMLButtonElement && menuPanel instanceof HTMLElement) {
        const setMenuOpen = (isOpen) => {
            menuButton.classList.toggle('is-open', isOpen);
            menuPanel.classList.toggle('is-open', isOpen);
            menuButton.setAttribute('aria-expanded', String(isOpen));
            menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
        };

        const isMenuOpen = () => menuPanel.classList.contains('is-open');

        menuButton.addEventListener('click', () => {
            setMenuOpen(!isMenuOpen());
        });

        // Close on outside click/tap
        document.addEventListener('click', (event) => {
            if (!isMenuOpen()) return;
            const target = event.target;
            if (!(target instanceof Node)) return;

            const menuRoot = menuButton.closest('.header-menu');
            if (menuRoot && menuRoot.contains(target)) return;

            setMenuOpen(false);
        });

        // Close on Escape
        document.addEventListener('keydown', (event) => {
            if (!isMenuOpen()) return;
            if (event.key !== 'Escape') return;
            setMenuOpen(false);
            menuButton.focus();
        });

        // Menu items are "coming soon" (pages not created yet)
        menuPanel.addEventListener('click', (event) => {
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;

            const link = target.closest('a.menu-item');
            if (!(link instanceof HTMLAnchorElement)) return;

            const isComingSoon = link.getAttribute('data-coming-soon') === 'true';
            if (isComingSoon) {
                event.preventDefault();
                setMenuOpen(false);
            }
        });

        // Ensure closed on load
        setMenuOpen(false);
    }
});

// -----------------------------------------------------------------------------
// 2. YOUR CUSTOM FUNCTIONS GO HERE
// -----------------------------------------------------------------------------

// Add your custom functions and event listeners here

// -----------------------------------------------------------------------------
// 3. ERROR HANDLING
// -----------------------------------------------------------------------------

window.addEventListener('error', function(e) {
    console.error('❌ JavaScript Error:', e.error);
});

window.addEventListener('unhandledrejection', function(e) {
    console.error('❌ Unhandled Promise Rejection:', e.reason);
});
